export default {
  name: 'GcIconNav',
  computed: {
    navType() {
      return (this.type === 'icon' ? 'gc__icon__nav' : 'gc__base__nav');
    },
    navLinkType() {
      return (this.type === 'icon' ? 'gc__icon__nav__link' : 'gc__base__nav__link');
    },
    navLinkText() {
      return (this.type === 'icon' ? 'gc__icon__nav__link__icon' : 'gc__base__nav__link__text');
    },
  },
  props: {
    type: {
      type: String,
      default: 'icon',
    },
    backgroundColor: {
      type: String,
      default: 'LightGray',
    },
    links: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
